import random from "lodash/random";

import defaultImg1 from "@/../../hypetrain/static/img/img-article-card-default-1.png";
import defaultImg2 from "@/../../hypetrain/static/img/img-article-card-default-2.png";
import defaultImg3 from "@/../../hypetrain/static/img/img-article-card-default-3.png";
import defaultImg4 from "@/../../hypetrain/static/img/img-article-card-default-4.png";

const defaultImgs = [defaultImg1, defaultImg2, defaultImg3, defaultImg4];
export const getRandomDefaultImg = () => defaultImgs[random(0, 3)];
